import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book mt-1" }, null, -1)
const _hoisted_2 = { class: "d-none d-md-block ms-2" }

import { DialogHandler } from "../../../components/dialog/DialogHandler"
import {  useRouter } from 'vue-router';
import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { translation } from '../../../lang/Translation';

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpButton',
  setup(__props) {

const router = useRouter();
const t = translation;
const showDocument = async () => {
  // DialogHandler.showDocumentSlideDialog();
  if(await MessageDialog.confirm(t.to("新しいタブでドキュメントページを開きます。よろしいですか？","confirm_open_doc"))){
    window.open("https://github.com/levelenter/blockvrock_doc#readme","__blank")
  }
};
const buttonName = t.to("ドキュメント","document")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "d-flex btn btn-outline-secondary btn-lg me-2",
    onClick: showDocument
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(buttonName)), 1)
  ]))
}
}

})